/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : rootReducer.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Redux Root Reducer
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 12, 2020
 * Description   : Add code to define root reducer
 *
 *
 ******************************************************************************/

import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from 'stores/AuthStore';
import { customerReducer } from 'stores/CustomerStore';
import { configReducer } from 'stores/ConfigurationStore';
import { orderReducer } from 'stores/OrderSearchStore';
import { uiReducer } from 'stores/UIStore';
import { confirmStcReducer } from 'stores/ConfirmStcStore';
import { configureWorkFlowReducer } from 'stores/ConfigureWorkFlowStore';

const rootReducer = combineReducers({
  auth: authReducer,
  customer: customerReducer,
  configuration: configReducer,
  order: orderReducer,
  confirmStc: confirmStcReducer,
  ui: uiReducer,
  configureWorkFlow: configureWorkFlowReducer,
});

export default rootReducer;
